
import "./Navbar.css";
import Logo from "./component/Logo";
import LanguageToolbar from "../LanguageToolbar/LanguageToolbar";
import { useTranslation } from 'react-i18next';
const Navbar = (props) => {
  const { toggleHeader, children } = props;

  const { t } = useTranslation();


  return (
    <div className="ContainerHeaderNav">
      <nav className="navbar navbar-dark Navbar">
        <div className="container-fluid ContainerNav">
          <Logo />
          <LanguageToolbar handleLanguageChange={props.handleLanguageChange} />

        </div>
      </nav>
    </div>
  );
};

export default Navbar;
